import { PresentationHeaderFontFace } from '@/types/schema';

import { BrandingColorInputProps } from './BrandingColorInput';

export const colorInputDefinitionsPrimary: Pick<
  BrandingColorInputProps,
  'heading' | 'subheading' | 'fieldName'
>[] = [
  {
    heading: 'Primary brand color',
    subheading: 'Presentation titles and headers',
    fieldName: 'primaryColor',
  },
  {
    heading: 'Button & link color',
    subheading: 'Button and link colors in client web proposals',
    fieldName: 'buttonsLinkColor',
  },
];

export const colorInputDefinitionsDataviz: Pick<
  BrandingColorInputProps,
  'heading' | 'subheading' | 'fieldName'
>[] = [
  {
    heading: 'Main data visualization',
    subheading: 'Primary color on visualizations',
    fieldName: 'dataVisualizationPrimaryColor',
  },
  {
    heading: 'Secondary data visualization',
    subheading: 'Secondary color on visualizations',
    fieldName: 'dataVisualizationSecondaryColor',
  },
  {
    heading: 'Tertiary data visualization',
    subheading: 'Tertiary color on visualizations',
    fieldName: 'dataVisualizationTertiaryColor',
  },
  {
    heading: 'Negative data visualization',
    subheading: 'Loss or tax-related colors on visualizations',
    fieldName: 'dataVisualizationNegativeColor',
  },
];

export const defaultFormValues = {
  primaryColor: '#FFFFFF',
  secondaryColor: '#FFFFFF',
  dataVisualizationPrimaryColor: '#FFFFFF',
  dataVisualizationSecondaryColor: '#FFFFFF',
  dataVisualizationTertiaryColor: '#FFFFFF',
  dataVisualizationNegativeColor: '#FFFFFF',
  buttonsLinkColor: '#FFFFFF',
  presentationHeaderFontFace: PresentationHeaderFontFace.Default,
};
